export default __webpack_public_path__ + "static/media/ph_horizontal.65999335.png";